export default __webpack_public_path__ + "static/media/080_finish_good.c5887cee.mp4";